module.exports = __webpack_public_path__ + "static/media/filename (8).9a070683.png";